import React from 'react';
import NumberFormat from 'react-number-format';
import cx from 'classnames';
import style from './price.module.scss';

const DISPLAY_TYPES = {
	TEXT: 'text',
	INPUT: 'input',
};

const Currency = ({
	value,
	currencyClassName,
	displayType = DISPLAY_TYPES.TEXT,
	currency = 'TL',
	isPrice = true,
	...props
}) => {
	const getValue = () => {
		if (isPrice) {
			return Math.trunc(value * 100) / 100;
		}

		return value;
	};

	return (
		<>
			<NumberFormat
				value={getValue()}
				displayType={displayType}
				decimalScale={2}
				fixedDecimalScale
				thousandSeparator="."
				suffix={displayType === DISPLAY_TYPES.INPUT ? ' TL': ''}
				decimalSeparator=","
				allowNegative={false}
				{...props}
			/>
			{displayType === DISPLAY_TYPES.TEXT && currency &&
        <span className={cx(style.currency, currencyClassName)}>{' '}{currency}</span>}
		</>
	);
}
;

export default Currency;
